import styled, {css} from "styled-components";
import {FaPlus} from "react-icons/fa";
import {ScrollWrap} from "./CommonStyles";

const Wrapper = styled.div`
    border-radius: 12px;
    position: relative;
    width: 100%;
  max-height: 100vh;
  overflow-y: auto;
    background-color: ${props => props.theme.primaryBg};
  
  @media screen and (max-width: 480px) {
    position: fixed;
    height: 100vh;
    width: 100%;
    left: 0;
    top: 0;
  }
`

const ImageWrapper = styled.div`
    //position: relative;
    //top: -70px;
    left: calc(50% - 35px);
  display: flex;
  justify-content: center;
  align-items: center;
`

const Header = styled.div`
    width: 100%;
    text-align: center;
    font-size: 1.1rem;
    color: ${props => props.theme.mainOrange};
    padding: 15px 0;
    border-bottom: 1px solid ${props => props.theme.color}15;
`

const PriceBoard = styled.div`
    width: 90%;
    padding: 20px 10px;
    background-color: ${props => props.theme.input};
    border-radius: 8px;
`

const ReceiveBoard = styled(PriceBoard)`
    padding: 15px 10px;
    background-color: ${props => props.theme.mainGreen}20;
`

const WalletWrapper = styled.div`
  width: 60%;
  height: 32px;
  border-radius: 12px;
  display: flex;
  background-color: ${props => props.theme.color};
`

const WalletTab = styled.div`
  width: 50%;
  height: 32px;
  transition: all 0.3s;
  border-radius: inherit;
  font-size: 0.9rem;
  cursor: pointer;
  color: ${props => props.theme.mainBg};
  ${props => props.active && css`
    background-color: ${props => props.theme.mainOrange};
    color: #0d1726;
  `};
`

const Network = styled.div`
  border: 1px solid ${props => props.theme.color}80;
  background-color: ${props => props.theme.tInputBg};
  color: ${props => props.theme.color};
  margin: 5px;

  ${props => props.active && css`
    background-color: ${props => props.theme.mainBg};
    color: ${props => props.theme.mainOrange};
    border: 1px solid ${props => props.theme.color};

  `};
  cursor: pointer;
  border-radius: 12px;
  min-width: 80px;
  min-height: 28px;
  font-size: 0.9rem;
  font-family: Roboto,serif;
  display: flex;
  justify-content: center;
  align-items: center;
`

const AddIcon = styled(FaPlus)`
  color: ${props => props.theme.color};
  margin: 0 10px;
  cursor: pointer;
  position: relative;
`

const LineBreak = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.color}20;
`

const InvoiceWrapper = styled(ScrollWrap)`
    
    @media screen and (max-width: 768px) {
      height: 100vh;
    }
`

export {
    WalletWrapper,
    WalletTab,
    PriceBoard,
    ReceiveBoard,
    Wrapper,
    ImageWrapper,
    Header,
    Network,
    AddIcon,
    LineBreak,
    InvoiceWrapper
}
